import Colors from '../../styles/Colors';

// Chakra style objects (consumed via rocket `css=` / style props, NOT inline
// `style={}` on native DOM — semantic tokens only resolve through Chakra).
//
// Neutral surfaces/borders use semantic tokens (`bg.subtle`, `border`) so they
// flip when dark mode lands; the green/red status colours are brand/status and
// deliberately stay as Colors.*.
//
// The old JSS `& p` / `& svg` nested rules are dropped: the row renders <span>,
// not <p>, and the icons carry explicit width/height, so neither rule did
// anything. The status cell keeps `flexDirection: column` (the call site's
// inline style only ever overrode display/alignItems/gap).
const STATUS_BASE = {
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  textAlign: 'center',
  padding: '15px 30px',
} as const;

export const insertTextPreviewStyles = {
  tableHead: { bg: 'bg.subtle' },
  insertTextCell: {
    fontSize: '1.3rem',
    fontStyle: 'italic',
    borderRightWidth: '1px',
    borderColor: 'border',
  },
  insertScoreCell: {
    fontSize: '1.3rem',
    borderRightWidth: '1px',
    borderColor: 'border',
  },
  insertTextGreen: { ...STATUS_BASE, color: Colors.green },
  insertTextRed: { ...STATUS_BASE, color: Colors.red },
};
